import { z } from 'zod';

export const optionalString = () => z.string().optional().nullable();
export const optionalBoolean = () => z.boolean().optional().nullable();
export const optionalNumber = () => z.number().optional().nullable();
export const optionalDate = () => z.union([z.date(), z.string()]).optional().nullable();

export const TransitAddressSchema = z.object({
  streetAndNumber: optionalString(),
  postcode: optionalString(),
  city: optionalString(),
  country: optionalString(),
  houseNumber: optionalString(),
});

export const TransitContactPersonSchema = z.object({
  name: optionalString(),
  phoneNumber: optionalString(),
  eMailAddress: optionalString(),
});

export const TransitDocumentSchema = z.object({
  sequenceNumber: optionalString(),
  type: optionalString(),
  referenceNumber: optionalString(),
  documentLineItemNumber: optionalString(),
  goodsItemNumber: optionalString(),
  typeOfPackages: optionalString(),
  numberOfPackages: optionalString(),
  measurementUnitAndQualifier: optionalString(),
  quantity: optionalString(),
  complementOfInformation: optionalString(),
  code: optionalString(),
  text: optionalString(),
});

export const TransitCustomsOfficeSchema = z.object({
  sequenceNumber: optionalString(),
  referenceNumber: optionalString(),
  arrivalDateAndTimeEstimated: optionalString(),
});

export const ConsignorOrConsigneeOrCarrierSchema = z.object({
  identificationNumber: optionalString(),
  name: optionalString(),
  Address: TransitAddressSchema.optional(),
  ContactPerson: TransitContactPersonSchema.optional(),
});

export const TransitAdditionalSupplyChainActorSchema = z.object({
  sequenceNumber: optionalString(),
  role: optionalString(),
  identificationNumber: optionalString(),
});

export const SealSchema = z.object({
  sequenceNumber: optionalString(),
  identifier: optionalString(),
});

export const GoodsReferenceSchema = z.object({
  sequenceNumber: optionalString(),
  declarationGoodsItemNumber: optionalString(),
});

export const TransitTransportEquipmentSchema = z.object({
  sequenceNumber: optionalString(),
  containerIdentificationNumber: optionalString(),
  numberOfSeals: optionalString(),
  Seal: z.array(SealSchema).optional(),
  GoodsReference: z.array(GoodsReferenceSchema).optional(),
});

export const TransitDepartureTransportMeansSchema = z.object({
  sequenceNumber: optionalString(),
  typeOfIdentification: optionalString(),
  identificationNumber: optionalString(),
  nationality: optionalString(),
});

export const TransitActiveBorderTransportMeansSchema = z.object({
  sequenceNumber: optionalString(),
  customsOfficeAtBorderReferenceNumber: optionalString(),
  typeOfIdentification: optionalString(),
  identificationNumber: optionalString(),
  nationality: optionalString(),
  conveyanceReferenceNumber: optionalString(),
});

export const TransitCountryOfRoutingOfConsignmentSchema = z.object({
  sequenceNumber: optionalString(),
  country: optionalString(),
});

export const PlaceOfLoadingOrUnloadingSchema = z.object({
  UNLocode: optionalString(),
  country: optionalString(),
  location: optionalString(),
});

export const TransportChargesSchema = z.object({
  methodOfPayment: optionalString(),
});

export const TransitGNSSSchema = z.object({
  latitude: optionalString(),
  longitude: optionalString(),
});

export const TransitEconomicOperatorSchema = z.object({
  identificationNumber: optionalString(),
});

export const TransitLocationOfGoodsSchema = z.object({
  typeOfLocation: optionalString(),
  qualifierOfIdentification: optionalString(),
  authorisationNumber: optionalString(),
  additionalIdentifier: optionalString(),
  UNLocode: optionalString(),
  country: optionalString(),
  CustomsOffice: TransitCustomsOfficeSchema.optional(),
  GNSS: TransitGNSSSchema.optional(),
  EconomicOperator: TransitEconomicOperatorSchema.optional(),
  Address: TransitAddressSchema.optional(),
  PostcodeAddress: TransitAddressSchema.optional(),
  ContactPerson: TransitContactPersonSchema.optional(),
});

export const TransitCustomsStateNotificationSchema = z.object({
  _id: z.any().optional(),
  notificationType: optionalString(),
  message: optionalString(),
  read: optionalBoolean(),
  createdAt: z.union([z.date(), z.string()]).optional().nullable(),
});
